import { Select } from 'antd'
import React, { Dispatch, SetStateAction } from 'react'
import styled from 'styled-components'

export type OneStepSelectOption = {
  label: string
  value: string
}

export type OneStepSelectProps = {
  options: ReadonlyArray<OneStepSelectOption>
  selectedValue: string
  setSelectedValue: Dispatch<SetStateAction<string>>
  placeholder?: string
  width?: React.CSSProperties['width']
}

const InputContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: left;
  align-items: center;
`

export const OneStepSelect: React.FC<OneStepSelectProps> = ({
  options,
  selectedValue,
  setSelectedValue,
  placeholder = 'Select an option',
  width = '500px',
}) => {
  const handleChange = (value: string) => {
    setSelectedValue(value)
  }

  return (
    <InputContainer>
      <Select
        options={[...options]}
        value={selectedValue}
        onChange={handleChange}
        placeholder={placeholder}
        style={{ width }}
        getPopupContainer={(triggerNode) =>
          triggerNode.parentNode as HTMLElement
        }
      />
    </InputContainer>
  )
}
